import { motion } from "framer-motion";
import { Skull, Sparkles } from "lucide-react";
import { INK_ART } from "@/lib/site";

const PROMPT = "Teschio con cuffie e fumo";
const STYLES = ["Neo-trad", "Old school", "Fine line", "Blackwork"];
const RESULTS = [INK_ART.skull, INK_ART.panther, INK_ART.mic, INK_ART.machine];

const Typed = () => (
  <motion.span initial="hidden" animate="show" variants={{ show: { transition: { staggerChildren: 0.035, delayChildren: 0.2 } } }}>
    {PROMPT.split("").map((c, i) => (
      <motion.span key={i} variants={{ hidden: { opacity: 0 }, show: { opacity: 1 } }}>{c}</motion.span>
    ))}
    <motion.span className="ml-px inline-block h-3 w-px bg-[#16E0F0] align-middle" animate={{ opacity: [1, 0] }} transition={{ duration: 0.6, repeat: Infinity }} />
  </motion.span>
);

const Tile = ({ src, i }) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.85, filter: "blur(8px)" }}
    animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
    transition={{ delay: 1.2 + i * 0.12, duration: 0.6 }}
    className={`relative flex aspect-square items-center justify-center rounded-xl border bg-[#17171B] p-2 ${i === 0 ? "border-[#16E0F0]" : "border-[#2B2B31]"}`}
  >
    <img src={src} alt="" className="h-full w-full object-contain" />
    {i === 0 && <span className="absolute left-1.5 top-1.5 rounded-sm bg-[#16E0F0] px-1 text-[7px] font-extrabold uppercase text-black">Nuovo</span>}
  </motion.div>
);

const Client = () => (
  <div className="mt-3 flex items-center gap-2.5 rounded-xl border border-[#2B2B31] bg-[#17171B] px-2.5 py-2">
    <span className="flex h-8 w-8 items-center justify-center rounded-full border border-[#2B2B31] bg-[#0B0B0D]"><Skull className="h-3.5 w-3.5 text-[#E03A3A]" /></span>
    <span className="flex-1">
      <span className="block text-[10.5px] font-extrabold">Marco &apos;Il Boss&apos;</span>
      <span className="block text-[8.5px] text-[#9A9AA0]">Teschio sul braccio · <span className="font-bold text-[#16E0F0]">Budget 80$</span></span>
    </span>
  </div>
);

export const AIScreen = () => (
  <div className="flex h-full flex-col bg-[#0B0B0D] px-3.5 pb-16 pt-12 text-white" data-testid="app-screen-ia">
    <p className="text-[8px] font-bold uppercase tracking-[0.3em] text-[#16E0F0]">Studio · AI</p>
    <p className="mt-1 text-[22px] font-extrabold leading-none tracking-tight">Generatore IA</p>
    <Client />
    <div className="mt-2 rounded-xl border border-[#2B2B31] px-2.5 py-2">
      <p className="text-[7.5px] font-bold uppercase tracking-[0.2em] text-[#9A9AA0]">Descrivi il tattoo</p>
      <p className="mt-1 text-[10.5px] font-semibold"><Typed /></p>
    </div>
    <div className="mt-2 flex flex-wrap gap-1">
      {STYLES.map((s, i) => (
        <span key={s} className={`rounded-full px-2 py-1 text-[7.5px] font-extrabold uppercase tracking-wider ${i === 0 ? "bg-[#E03A3A] text-white" : "border border-[#2B2B31] text-[#9A9AA0]"}`}>{s}</span>
      ))}
    </div>
    <span className="mt-2.5 flex items-center justify-center gap-1.5 rounded-md bg-[#16E0F0] py-2 text-[10px] font-extrabold uppercase tracking-wider text-black">
      <Sparkles className="h-3 w-3" /> Genera
    </span>
    <div className="mt-2.5 grid grid-cols-2 gap-1.5">
      {RESULTS.map((src, i) => <Tile key={src} src={src} i={i} />)}
    </div>
  </div>
);
